const SystemContainer = ({ children }) => {
	return children;
};

export default SystemContainer;
